module.exports = __webpack_public_path__ + "static/media/file-dropzone-icon.adeb23e2.svg";